import { C } from "../../shared/theme";

// A card on Today that folds away: Today's Inspiration (on Today) and Today's Reminders (Craig, 24 Oct 2026:
// "design the Today's Reminders section to look and collapse / expand the same way as the Today's Inspiration
// section"). Built like Today's Morning, Afternoon and Evening cards: a header with an icon, the title and a line under
// it, and when open a body inside the same card, so it is clear where the fold ends. The sections inside keep their
// own taps; the fold only shows or hides them. `help` (a HelpTip) sits just left of ▲, so every card's ▲ lines up
// at the right edge; it lies over the header rather than inside its button, because a button can't hold a button.
// HelpTip is a 44px tap area around a 22px circle; the title stops short of where it sits, left of ▲.
const HELP_RIGHT = 38, TITLE_ROOM_FOR_HELP = 36;

export function FoldCard({ id, icon, title, line, open, onToggle, help = null, children }) {
  const bodyId = `${id}-fold`, titleId = `${id}-fold-title`, lineId = `${id}-fold-line`;
  return (
    <section style={{ marginBottom: 10, background: C.foldBody, border: `1px solid ${C.borderCard}`, borderRadius: C.r, boxShadow: C.shadow, overflow: "hidden" }}>
      <div style={{ position: "relative", background: C.surface }}>
        <h2 style={{ margin: 0 }}>
          <button onClick={onToggle} aria-expanded={open} aria-controls={open ? bodyId : undefined} aria-labelledby={titleId} aria-describedby={lineId}
            style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, padding: "13px 16px", background: "none", border: "none", textAlign: "left", cursor: "pointer", fontFamily: "inherit" }}>
            <span style={{ display: "flex", alignItems: "center", gap: 8, paddingRight: help ? TITLE_ROOM_FOR_HELP : 0 }}>
              <span aria-hidden="true" style={{ fontSize: 17 }}>{icon}</span>
              <span>
                <span id={titleId} style={{ display: "block", fontWeight: 700, fontSize: 18, color: C.text }}>{title}</span>
                <span id={lineId} style={{ display: "block", fontWeight: 400, fontSize: 14, color: C.textDim }}>{line}</span>
              </span>
            </span>
            <span aria-hidden="true" style={{ color: C.textGreen, fontSize: 11 }}>{open ? "▲" : "▼"}</span>
          </button>
        </h2>
        {help && <span style={{ position: "absolute", right: HELP_RIGHT, top: "50%", transform: "translateY(-50%)", display: "flex" }}>{help}</span>}
      </div>
      {open && <div id={bodyId} style={{ padding: 12, display: "grid", gap: 10, borderTop: `1px solid ${C.borderCard}` }}>{children}</div>}
    </section>
  );
}
